<template>
  <div class="field is-horizontal">
    <div class="field-label is-normal">
      <label class="label">{{ label }}</label>
    </div>
    <div class="field-body">
      <div class="field">
        <table class="table field-horizontal-table">
          <slot />
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "field-horizontal-table",
  props: ["label"]
}
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";

@include mobile() {
  .table.field-horizontal-table {
    width: 100%;
    tr {
      border: 1px solid $grey-lighter;
      margin: 0.75em 0;
      display: block;
      td {
        display: block;
        border: 0 none;
        &:nth-last-child(2) {
          border: none;
          float: right;
        }
        &:nth-last-child(3) {
          width: 50%;
          display: inline-block;
        }
      }
    }
  }
}
</style>
